import useDebouncedEventListener from "@Hooks/eventListeners/useDebouncedEventListener";

/**
 * Adds debounce to scroll event listener
 */
export default function useDebouncedScroll(handleScroll: (any?) => any, wait: number = 250) {
    useDebouncedEventListener('scroll', handleScroll, wait)
}